import { NgModule } from '@angular/core';
import { EffectsModule } from '@ngrx/effects';

import { ContractsEffects } from '@appStore/contracts/effects/contracts.effects';
import { BudgetsEffects } from '@appStore/contracts/effects/budgets.effects';
import { AgreementEffects } from '@appStore/contracts/effects/agreements.effects';

export const effects = [ContractsEffects, BudgetsEffects, AgreementEffects];

@NgModule({
  imports: [EffectsModule.forFeature(effects)]
})
export class ContractsEffectsModule {}
